class ManagePurchaseNavbar {
  constructor (I18n) {
    'ngInject'
    this.I18n = I18n
  }
}

export default ManagePurchaseNavbar



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/common/manage-purchase-navbar/manage-purchase-navbar.controller.js